import dashboardChartsSlice from './slice';

export const {
    setSelectedDashboard,
    setSelectedDashboardSuccess,
    getDashbardsList,
    getDashbardsListSuccess,
    getDashbardsListError,
    setSelectedDashboardError,
    setSelectedCompanyofDashborad,
    setSelectedCompanyofDashboradSuccess,
    setSelectedCompanyofDashboradError
} = dashboardChartsSlice.actions; 
export default dashboardChartsSlice.reducer;

export * from './types';